import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { getRentalPortalListingLogEvents } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { useInfiniteItemsListLoader, useTimeZone } from '../../../../../hooks'
import { EntityProfileTabUpdates } from '../../../../Entity'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'

import { LISTING_UPDATES_PAGE_SIZE } from './RentalPortalListingProfileUpdates.constants'
import { toTranslatedListingUpdates } from './RentalPortalListingProfileUpdates.utils'

function RentalPortalListingProfileUpdates() {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const { listingData } = useListingProfileContext()

  const listingId = listingData?.id

  const listingUpdatedAt = listingData?.updated

  const {
    getThresholdItemProps,
    hasError,
    items,
    loadingInitial,
    loadingMore,
    updateListData,
  } = useInfiniteItemsListLoader({
    apiParams: {
      listing_id: listingId,
      page_size: LISTING_UPDATES_PAGE_SIZE,
    },
    getData: getRentalPortalListingLogEvents,
    loadPermission: Boolean(listingId),
    withPagination: true,
  })

  const loadedUpdatedAtRef = useRef(listingUpdatedAt)

  useEffect(() => {
    if (listingUpdatedAt !== loadedUpdatedAtRef.current) {
      if (loadedUpdatedAtRef.current && listingUpdatedAt) {
        updateListData()
      }

      loadedUpdatedAtRef.current = listingUpdatedAt
    }
  }, [listingUpdatedAt])

  return (
    <EntityProfileTabUpdates
      getThresholdItemProps={getThresholdItemProps}
      hasError={hasError}
      isLoading={loadingInitial}
      isLoadingMore={loadingMore}
      items={toTranslatedListingUpdates({
        items: items ?? EMPTY_LIST,
        listing: listingData,
        t,
        timezone,
      })}
    />
  )
}

export default RentalPortalListingProfileUpdates
